export const navigateToPage = (url: string): void => {
  window.location.href = url;
};
